// src/Components/CustomDropdown.js
import React, { useState } from 'react';
import '../StyleComponent/CustomDropdown.css'; // Ensure to include your CSS file

const CustomDropdown = ({ options, selectedValue, onSelect, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownAbove, setIsDropdownAbove] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    // Check if dropdown should be above or below
    const dropdownHeader = document.querySelector('.dropdown-header');
    const dropdownList = document.querySelector('.dropdown-list');
    if (dropdownList && dropdownHeader) {
      const headerRect = dropdownHeader.getBoundingClientRect();
      const listHeight = dropdownList.offsetHeight;
      setIsDropdownAbove(headerRect.bottom + listHeight > window.innerHeight);
    }
  };

  const handleSelect = (value) => {
    onSelect(value);
    setIsOpen(false);
  };

  return (
    <div className="custom-dropdown" >
      <div
        className={`dropdown-header ${isOpen ? 'active' : ''}`}
        onClick={handleToggle}
      >
        {selectedValue ? options.find(option => option.value === selectedValue).label : placeholder}
        <div className={`arrow1 ${isOpen ? 'up' : ''}`}></div>
      </div>
      {isOpen && (
        <div className={`dropdown-list ${isDropdownAbove ? 'dropdown-list-up' : 'dropdown-list-down'}`}>
          {options.map(option => (
            <div
              key={option.value}
              className={`dropdown-item ${selectedValue === option.value ? 'selected' : ''}`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
